import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AccountService } from "@app-cmc/core";

@Component({
  selector: "app-pending-configuration",
  templateUrl: "./pending-configuration.component.html",
  styleUrls: ["./pending-configuration.component.scss"]
})
export class PendingConfigurationComponent implements OnInit {
  constructor(private accountService: AccountService, private router: Router) {}

  ngOnInit(): void {
    if (this.accountService.user.configured) this.router.navigate(["/"]);
  }

  getSeconds(t) {
    return Math.floor((t / 1000) % 60);
  }
}
